import Act from "../../../../store/actions";
import eventTypeHelper from "./eventTypeHelper";
import { SNA_BASIC_SETTING } from "../../../../config/config.sna";
import {
  getGroupDataset,
  getPersonalDataset,
  getPublicDataset,
} from "../../service/datasetService";
import { getEventTypes } from "../../service/filterService";
import { getUserSettings } from "../../service/settingService";
import fstDb from "../../../../api/firebase/firestore/utils";

export const fetchUserSetting = async (user, dispatch) => {
  // fetch firebase realtime 設定
  const settings = await getUserSettings(user?.uid);

  const {
    adjust_nodeColors: adjustNodeColors,
    adjust_linkColors: adjustLinkColors,
    adjust_nodePlaceMode: adjustNodePlaceMode,
    adjust_nodeShowNodeCount: adjustNodeShowNodeCount,
    adjust_nodeDispersion: adjustNodeDispersion,
    adjust_legendShowNodDataGroup: adjustLegendShowNodDataGroup,
    filter_nodeCount: filterNodeCount,
    filter_linkCount: filterLinkCount,
    filter_timePeriod: filterTimePeriod,
    filter_startEndDate: filterStartEndDate,
  } = settings || {};
  // adjust tool setting
  dispatch({
    type: Act.SNA_ADJUST_NODE_COLORS_INITIAL,
    payload: adjustNodeColors || SNA_BASIC_SETTING.adjust_nodeColors,
  });
  dispatch({
    type: Act.SNA_ADJUST_NODE_COLORS_CHANGE,
    payload: adjustNodeColors || SNA_BASIC_SETTING.adjust_nodeColors,
  });
  //
  dispatch({
    type: Act.SNA_ADJUST_LINK_COLORS_INITIAL,
    payload: adjustLinkColors || SNA_BASIC_SETTING.adjust_linkColors,
  });
  dispatch({
    type: Act.SNA_ADJUST_LINK_COLORS_CHANGE,
    payload: adjustLinkColors || SNA_BASIC_SETTING.adjust_linkColors,
  });
  //
  dispatch({
    type: Act.SNA_ADJUST_NODE_PLACEMENT_INITIAL,
    payload: adjustNodePlaceMode || SNA_BASIC_SETTING.adjust_nodePlaceMode,
  });
  dispatch({
    type: Act.SNA_ADJUST_NODE_PLACEMENT_CHANGE,
    payload: adjustNodePlaceMode || SNA_BASIC_SETTING.adjust_nodePlaceMode,
  });
  //
  dispatch({
    type: Act.SNA_ADJUST_NODE_SHOW_NODE_COUNT_INITIAL,
    payload:
      adjustNodeShowNodeCount || SNA_BASIC_SETTING.adjust_nodeShowNodeCount,
  });
  dispatch({
    type: Act.SNA_ADJUST_NODE_SHOW_NODE_COUNT_CHANGE,
    payload:
      adjustNodeShowNodeCount || SNA_BASIC_SETTING.adjust_nodeShowNodeCount,
  });
  //
  dispatch({
    type: Act.SNA_ADJUST_NODE_DISPERSION_INITIAL,
    payload: adjustNodeDispersion || SNA_BASIC_SETTING.adjust_nodeDispersion,
  });
  dispatch({
    type: Act.SNA_ADJUST_NODE_DISPERSION_CHANGE,
    payload: adjustNodeDispersion || SNA_BASIC_SETTING.adjust_nodeDispersion,
  });
  //
  dispatch({
    type: Act.SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_INITIAL,
    payload:
      adjustLegendShowNodDataGroup ||
      SNA_BASIC_SETTING.adjust_legendShowNodDataGroup,
  });
  dispatch({
    type: Act.SNA_ADJUST_LEGEND_SHOW_NO_DATA_GROUP_CHANGE,
    payload:
      adjustLegendShowNodDataGroup ||
      SNA_BASIC_SETTING.adjust_legendShowNodDataGroup,
  });
  // filter tool setting
  dispatch({
    type: Act.SNA_FILTER_NODE_COUNT_INITIAL,
    payload: filterNodeCount || SNA_BASIC_SETTING.filter_nodeCount,
  });
  dispatch({
    type: Act.SNA_FILTER_NODE_COUNT_CHANGE,
    payload: filterNodeCount || SNA_BASIC_SETTING.filter_nodeCount,
  });
  dispatch({
    type: Act.SNA_FILTER_LINK_COUNT_INITIAL,
    payload: filterLinkCount || SNA_BASIC_SETTING.filter_linkCount,
  });
  dispatch({
    type: Act.SNA_FILTER_LINK_COUNT_CHANGE,
    payload: filterLinkCount || SNA_BASIC_SETTING.filter_linkCount,
  });
  // always set default timePeriod(避免資料量太大)
  dispatch({
    type: Act.SNA_FILTER_TIME_PERIOD_INITIAL,
    // payload: filterTimePeriod || SNA_BASIC_SETTING.filter_timePeriod,
    payload: SNA_BASIC_SETTING.filter_timePeriod,
  });
  // always set default timePeriod(避免資料量太大)
  dispatch({
    type: Act.SNA_FILTER_TIME_PERIOD_CHANGE,
    // payload: filterTimePeriod || SNA_BASIC_SETTING.filter_timePeriod,
    payload: SNA_BASIC_SETTING.filter_timePeriod,
  });

  // firebase 儲存的格式為 str,必須轉換成 Date 物件再儲存
  // dateStrArray: ['1927-01-04T16:00:00.000Z', '1930-08-15T16:00:00.000Z']
  const formatStrToDate = (dateStrArray) => {
    if (Array.isArray(dateStrArray) && dateStrArray.length > 0)
      return dateStrArray.map((item) => new Date(item));
    return null;
  };
  //
  dispatch({
    type: Act.SNA_FILTER_START_END_DATE_INITIAL,
    // payload:
    //   formatStrToDate(filterStartEndDate) ||
    //   SNA_BASIC_SETTING.filter_startEndDate,
    payload: SNA_BASIC_SETTING.filter_startEndDate,
  });
  dispatch({
    type: Act.SNA_FILTER_START_END_DATE_CHANGE,
    // payload:
    //   formatStrToDate(filterStartEndDate) ||
    //   SNA_BASIC_SETTING.filter_startEndDate,
    payload: SNA_BASIC_SETTING.filter_startEndDate,
  });

  // apply adjust setting
  dispatch({
    type: Act.SNA_APPLY_ADJUST_SETTING,
    payload: true,
  });
  // apply filter setting
  dispatch({
    type: Act.SNA_APPLY_FILTER_SETTING,
    payload: true,
  });
};

export const fetchPublicFiles = (user, dispatch) => {
  const onSuccess = (data) => {
    // 開放資料集資料
    const newPublicDataset = data.map((item) => ({
      ...item,
      id: item?.uid,
      authorId: item?.targetId,
      authorLabel: item?.targetLabel,
      checked: false,
    }));
    dispatch({
      type: Act.SNA_DATASET_PUBLIC,
      payload: [...newPublicDataset],
    });
    // 是否要保留作者節點
    const newAuthorPreserve = newPublicDataset.map((item) => ({
      ...item,
      checked: item.authorId !== "PER0", // 移除林獻堂節點
    }));
    dispatch({
      type: Act.SNA_FILTER_NODE_AUTHOR_PRESERVE_INITIAL,
      payload: [...newAuthorPreserve],
    });
    dispatch({
      type: Act.SNA_FILTER_NODE_AUTHOR_PRESERVE_CHANGE,
      payload: [...newAuthorPreserve],
    });

    dispatch({
      type: Act.SNA_REFRESH_PUBLIC_DATASET,
      payload: false,
    });
    dispatch({
      type: Act.SNA_APPLY_FETCH_DATASET,
      payload: true,
    });
  };
  const onNoData = () => {
    dispatch({
      type: Act.SNA_REFRESH_PUBLIC_DATASET,
      payload: false,
    });
    dispatch({
      type: Act.SNA_APPLY_FETCH_DATASET,
      payload: true,
    });
  };
  getPublicDataset({
    onSuccess,
    onNoData,
  });
};

// 取得個人的檔案
export const fetchPrivateFiles = (_user, dispatch) => {
  const onSuccess = (data) => {
    // 個人資料集資料
    const newPersonalDataset = data.map((item) => ({
      ...item,
      id: item?.uid,
    }));
    dispatch({
      type: Act.SNA_DATASET_PERSONAL,
      payload: [...newPersonalDataset],
    });
    dispatch({
      type: Act.SNA_REFRESH_PERSONAL_DATASET,
      payload: false,
    });
  };
  const onNoData = () => {
    dispatch({
      type: Act.SNA_DATASET_PERSONAL,
      payload: [],
    });
    dispatch({
      type: Act.SNA_REFRESH_PERSONAL_DATASET,
      payload: false,
    });
  };

  getPersonalDataset({ userId: _user?.uid, onSuccess, onNoData });
};

// 取得團隊的檔案
export const fetchGroupFiles = (group, dispatch) => {
  const onSuccess = (data) => {
    // 個人資料集資料
    const newGroupDataset = data.map((item) => ({
      ...item,
      id: item?.uid,
    }));
    dispatch({
      type: Act.SNA_DATASET_GROUP,
      payload: [...newGroupDataset],
    });
    dispatch({
      type: Act.SNA_REFRESH_GROUP_DATASET,
      payload: false,
    });
  };
  const onNoData = () => {
    dispatch({
      type: Act.SNA_DATASET_GROUP,
      payload: [],
    });
    dispatch({
      type: Act.SNA_REFRESH_GROUP_DATASET,
      payload: false,
    });
  };

  getGroupDataset({ groupId: group?.uid, onSuccess, onNoData });
};

/**
 * 取得事件分類
 * @param user
 * @param dispatch
 */
export const fetchEventTypes = (user, dispatch) => {
  const onSuccess = async (data) => {
    dispatch({
      type: Act.SNA_SET_EVN_CTG_SETTING_TOOL_ISLOADING,
      payload: true,
    });
    const result = await fstDb.readEvents(user.uid);
    const customEvent = result?.data?.events.reverse() || [];
    const tmpData = data.map((d) => ({
      ...d,
      checked: true,
    }));

    // 將 list 轉成階層式 data
    const root = eventTypeHelper.cvtToHierarchy(tmpData);
    // 將階層式 data 轉成 list (多帶一個key => step:0,1,2...)
    const evtTypesWithStep = eventTypeHelper
      .cvt2DataStep(root)
      // 移除 root(不用顯示)
      .filter((d) => d.id !== "EVTTYPE0");

    const sortedEvents = [];

    const collator = new Intl.Collator("zh-Hant-u-co-stroke", {
      numeric: true,
    });
    const combinedEvents = [...customEvent, ...evtTypesWithStep].sort((a, b) =>
      collator.compare(a.name, b.name)
    );

    const map = new Map();
    combinedEvents.forEach((el) => map.set(el.id, el));

    combinedEvents.forEach((el) => {
      if (el.pid === "EVTTYPE0") {
        sortedEvents.push(el);
        combinedEvents.forEach((event) => {
          if (event.pid === el.id) {
            sortedEvents.push(event);
          }
        });
      }
    });

    // 整理 data
    dispatch({
      type: Act.SNA_EVENT_TYPES_INITIAL,
      payload: sortedEvents,
    });
    dispatch({
      type: Act.SNA_EVENT_TYPES_CHANGE,
      payload: sortedEvents,
    });
    dispatch({
      type: Act.SNA_EVENT_TYPES_ORIGIN,
      payload: evtTypesWithStep,
    });
    dispatch({
      type: Act.SNA_EVENT_TYPES_CUSTOM,
      payload: customEvent,
    });
    dispatch({
      type: Act.SNA_SET_EVN_CTG_SETTING_TOOL_ISLOADING,
      payload: false,
    });
  };
  const onError = (err) => {
    dispatch({
      type: Act.COMMON_SET_ERROR_MESSAGE,
      payload: {
        open: true,
        content: err.message,
        duration: 5000,
      },
    });
  };
  getEventTypes({}, onSuccess, onError);
};
